import { useContextStore } from "@/stores/context";
import { useNotifications } from "@/components/useNotifications";

/**
 * Call this after parsing a !response.ok JSON body.
 * Returns true if it was a BOT_KICKED error and the redirect was triggered.
 */
export function handleBotKickedResponse(data: any, status: number): boolean {
    if (status === 404 && data?.error === "BOT_KICKED") {
        const contextStore = useContextStore();
        const { addNotification } = useNotifications();

        addNotification({
            type: "error",
            title: "Bot Removed",
            message: "The bot was removed from this server. Redirecting...",
            duration: 5000,
        });

        // Bust the frontend server list cache so the kicked server disappears
        contextStore.userServers = null;
        contextStore.clearServerSelection();

        // Lazy import breaks this module's participation in the
        // context.ts <-> router.ts import cycle.
        import("@/router").then(({ default: router }) => {
          router.replace({ name: "pages.servers", query: {} });
        });

        return true;
    }
    return false;
}